module.exports = __webpack_public_path__ + "static/img/about_us_banner.8d3ceda0.png";